let data = [
  {
    country: 'USA',
    Food: 4300,
    Beverage: 2400,
    Unspecified: 400
  },
  {
    country: 'UK',
    Food: 2010,
    Beverage: 1980,
    Unspecified: 220
  },
  {
    country: 'Germany',
    Food: 2000,
    Beverage: 2800,
    Unspecified: 290
  },
  {
    country: 'France',
    Food: 2780,
    Beverage: 3908,
    Unspecified: 200
  },
  {
    country: 'Netherlands',
    Food: 1890,
    Beverage: 4800,
    Unspecified: 280
  },
  {
    country: 'Spain',
    Food: 2390,
    Beverage: 3800,
    Unspecified: 500
  }
];

export default data;
